<valg-dk-page-layout
  [election]="election"
  [links]="links"
  [filterLinks]="filterLinks"
  [sideNavTitleType]="sideNavTitleType"
  [parentLinkType]="parentLinkType"
  [backLink]="breadcrumbs.previousBreadcrumb">
  <valg-dk-breadcrumbs #breadcrumbs></valg-dk-breadcrumbs>
  <div class="d-flex justify-content-between">
    <h1 class="h2 mt-0 mb-8 hyphenate">
      {{ 'page.details_page.municipality_title' | translate: {area: municipality} }}
    </h1>
    <button color="text-only" valgButton (click)="onDownloadReportClick()" class="hidden__sm">
      <mat-icon [svgIcon]="SvgIcon.Download"></mat-icon>
      {{ 'export_data.button_title' | translate }}
    </button>
  </div>
  <div class="row">
    <div class="col-12">
      <valg-card [border]="true" [custom]="true">
        <valg-dk-count-status title="count_status.title" [resultType]="resultType" [candidateDataLoadState]="candidateDataLoadState" [updated]="countStatusUpdated" [data]="countStatus"></valg-dk-count-status>
      </valg-card>
    </div>
    <div class="col-12 col-lg-6" *ngIf="!isRegionElection">
      <valg-card [border]="true" [custom]="true" class="p-0" height="490px">
        <valg-dk-mandates-list [data]="mandatesList" [resultSummary]="resultSummary" [basedOnMissingResults]="mandateDistributionBasedOnMissingResults"></valg-dk-mandates-list>
      </valg-card>
    </div>
    <div class="col-12 col-lg-6" *ngIf="!isRegionElection">
      <valg-card [border]="true" [custom]="true" class="p-0" height="490px">
        <valg-dk-candidate-mandates [data]="candidateMandates" [resultSummary]="resultSummary" [basedOnMissingResults]="mandateDistributionBasedOnMissingResults"></valg-dk-candidate-mandates>
      </valg-card>
    </div>
    <div class="col-12">
      <valg-card [border]="true" [custom]="true" class="p-0" *ngIf="showPartiesTable && !showReferendumStatus">
        <valg-dk-expandable-party-list
          #expandablePartyList
          [data]="candidateLists"
          [resultType]="resultType"
          [isCandidateList]="true"
          title="parties_table.candidatelist_title"
          [candidateDataLoadState]="candidateDataLoadState"
          [isCandidateListTable]="true"
          [resultSummary]="resultSummary"
        ></valg-dk-expandable-party-list>
      </valg-card>

      <valg-card [border]="true" [custom]="true" class="p-0" *ngIf="showReferendumStatus">
        <valg-dk-referendum-status [data]="referendumStatus" [election]="election"></valg-dk-referendum-status>
      </valg-card>
    </div>

    <div class="col-12 col-lg-6">
      <valg-card [border]="true" [custom]="true" class="p-0" *ngIf="electoralCoalitions && electoralCoalitions.length > 0">
        <valg-dk-electoral-coalition [data]="electoralCoalitions!"></valg-dk-electoral-coalition>
      </valg-card>

      <valg-card [border]="true" [custom]="true" class="p-0"
                 *ngIf="(coalitionList && coalitionList.length > 0)">
        <valg-dk-coalition-list [data]="coalitionList!"></valg-dk-coalition-list>
      </valg-card>

      <ng-container *ngTemplateOutlet="election?.electionType === ElectionType.RegionalElection ? districtTable : topCandidatesCard"></ng-container>
    </div>

    <div class="col-12 col-lg-6">
      <ng-container *ngTemplateOutlet="election?.electionType === ElectionType.RegionalElection ? topCandidatesCard : districtTable"
      ></ng-container>

      <ng-container>
        <ng-container *ngTemplateOutlet="topCandidatesCard; context: { isMobileView: true }"></ng-container>
      </ng-container>

      <valg-card [border]="true" [custom]="true">
        <valg-dk-voting-details [data]="votingDetails" [resultSummary]="resultSummary" [resultType]="resultType" [candidateDataLoadState]="candidateDataLoadState"></valg-dk-voting-details>
      </valg-card>
    </div>
  </div>

</valg-dk-page-layout>

<ng-template #topCandidatesCard let-isMobileView="isMobileView">
  <valg-card [border]="true" [custom]="true" class="p-0" [ngClass]="isMobileView ? 'd-lg-none' : 'd-none d-lg-block'">
    <valg-dk-top-candidates [resultSummary]="resultSummary" [resultType]="resultType" [data]="topCandidates"></valg-dk-top-candidates>
  </valg-card>
</ng-template>

<ng-template #districtTable>
  <valg-card [border]="true" [custom]="true" class="p-0">
    <valg-table
      [columnDefinition]="statusPollingDistrictColumnDef"
      [data]="statusPollingDistrict"
      [noDataMessage]="'status_polling_district.table.no_data_row'"
      [itemName]="'status_polling_district.table.item_name' | translate"
      [title]="'status_polling_district.table.title' | translate"
      [hasPagination]="false"
      [displayItemCount]="false"
      [hasMainActionButton]="false">
      <h2 class="m-0 text--f20 text--500">{{ 'status_polling_district.table.title' | translate }}</h2>
    </valg-table>
  </valg-card>
</ng-template>
